import type { i18n as I18nInstance } from 'i18next';
import { TENANT_TEXT_KEYS, type TenantTextOverrides } from '@pink/shared';

import { NAMESPACE } from './i18n.js';

/**
 * Legt die tenant-spezifischen Text-Overrides über die eingebauten Standardtexte.
 *
 * Pro Sprache und Key wird `i18n.addResource` aufgerufen (respektiert den
 * `.`-Key-Separator und nistet korrekt ein). Nur Keys aus dem
 * `TENANT_TEXT_CATALOG` werden übernommen — alles andere wird ignoriert
 * (Defense-in-Depth, falls die Config doch einen unbekannten Key enthält).
 * Wird vom `ConfigProvider` nach erfolgreichem Config-Fetch aufgerufen, bevor
 * die Screens mounten.
 */
export function applyTenantTextOverrides(
  i18n: I18nInstance,
  overrides: TenantTextOverrides | undefined,
): void {
  if (overrides === undefined) {
    return;
  }
  for (const [locale, perLocale] of Object.entries(overrides)) {
    if (perLocale === undefined) {
      continue;
    }
    for (const [key, text] of Object.entries(perLocale)) {
      if (TENANT_TEXT_KEYS.has(key) && typeof text === 'string' && text.length > 0) {
        i18n.addResource(locale, NAMESPACE, key, text);
      }
    }
  }
}
